import type { ExerciseDefinition } from '../types.ts';
import { candidatePitches, describeNoteIdConfig, staffClefFor, validateNoteIdConfig, type NoteIdConfig } from './config.ts';
import { generateNoteIdQuestions, skillsForPitch, type NoteIdExpected, type NoteIdPrompt } from './generate.ts';
import {
  gradeNoteId,
  noteIdFeedback,
  noteIdHint,
  parseNoteIdAnswer,
  type NoteIdAnswer,
  type NoteIdGradeCode,
} from './grade.ts';

export * from './config.ts';
export * from './generate.ts';
export * from './grade.ts';

export const NOTE_IDENTIFICATION = 'note-identification' as const;

export const noteIdentification: ExerciseDefinition<NoteIdConfig, NoteIdPrompt, NoteIdExpected, NoteIdAnswer, NoteIdGradeCode> = {
  type: NOTE_IDENTIFICATION,
  engineVersion: 1,
  label: 'Note identification',
  maxHintLevel: 2,
  validateConfig: validateNoteIdConfig,
  generate: generateNoteIdQuestions,
  grade: gradeNoteId,
  parseAnswer: (input, expected) => parseNoteIdAnswer(input, expected.answerMode),
  hint: noteIdHint,
  feedback: noteIdFeedback,
  describeConfig: describeNoteIdConfig,
  skillsFor(config) {
    const skills = new Set<string>();
    for (const pitchValue of candidatePitches(config)) {
      for (const skill of skillsForPitch(staffClefFor(config, pitchValue), pitchValue, config.answerMode)) skills.add(skill);
    }
    return [...skills];
  },
};
